import { Injectable } from '@angular/core';

@Injectable()
export abstract class Logger {
    public abstract get log(): (...params: any[]) => void;
    public abstract get warn(): (...params: any[]) => void;
    public abstract get error(): (...params: any[]) => void;
}

export interface ILogger {
    log(...params: any[]): void;
    warn(...params: any[]): void;
    error(...params: any[]): void;
}
